import React, { useState } from "react";
import PriceCard from "../components/PriceCard";
import { CustomSwitch } from "../components/CustomSwitch";
import FAQ from "../components/FAQ";

function PricingPage() {
  const [showMonthlyBill, setShowMonthlyBill] = useState(false);
  const selectedLanguage = localStorage.getItem("language");

  const translateText = (text) => {
    if (selectedLanguage === "arabic") {
      return text === "Service Prices"
        ? "أسعار الخدمة"
        : text === "(Save 16%)"
        ? "(وفّر 16%)"
        : text === "Annual Bill"
        ? "فاتورة سنوية"
        : text === "Monthly Bill"
        ? " فاتورة شهرية "
        : text;
    } else return text;
  };

  return (
    <div className="pos-wrapper prices-wrapper-homepage ">
      <div className={`main-content pb-5 `}>
        <div>
          <p className="text-center heading">{translateText("Service Prices")}</p>
          <div className="d-flex  w-100 justify-content-center align-items-center main-wrapper whitespace-nowrap" style={{ marginTop: "2rem" }}>
            <div className={`${selectedLanguage === "arabic" ? "rtl" : "ltr"} ${showMonthlyBill ? "inactive-text" : "save-text"} `}>
              {translateText("(Save 16%)")}
            </div>
            <div className={`${showMonthlyBill ? "inactive-text" : "active-text"} `}>{translateText("Annual Bill")}</div>
            <div className={`price-switch-wrapper mr-custom`} style={{ marginTop: selectedLanguage === "arabic" ? "-.9rem" : "-2.3rem" }}>
              <CustomSwitch
                value={showMonthlyBill}
                onChange={(e) => setShowMonthlyBill(e?.target?.checked)}
                name={"switch"}
                className={`${selectedLanguage === "arabic" ? "arabic-switch" : "switch"}`}
              />
            </div>
            <div className={`${!showMonthlyBill ? "inactive-text" : "active-text"} `}> {translateText("Monthly Bill")} </div>
          </div>

          <div
            className="w-100 prices-container d-flex d-sm-flex d-lg-flex  justify-content-lg-center align-items-sm-center  justify-content-sm-start align-items-sm-start"
            // className="w-100 prices-container d-flex justify-content-lg-start align-items-center overflow-lg-auto"
            style={{
              marginTop: "5rem",
              gap: "2rem",
              flexWrap: "nowrap",
            }}
          >
            <div className="flex-shrink-0">
              <PriceCard monthly={showMonthlyBill} />
            </div>
            <div className="flex-shrink-0">
              <PriceCard isActive={false} />
            </div>
          </div>
        </div>
      </div>
      <div className="faqs-wrapper">
        <FAQ />
      </div>
    </div>
  );
}

export default PricingPage;
